import { render, staticRenderFns } from "./OpdrItemsHeaderUitgezet.vue?vue&type=template&id=0236f0d6&scoped=true&"
import script from "./OpdrItemsHeaderUitgezet.vue?vue&type=script&lang=js&"
export * from "./OpdrItemsHeaderUitgezet.vue?vue&type=script&lang=js&"
import style0 from "./OpdrItemsHeaderUitgezet.vue?vue&type=style&index=0&id=0236f0d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236f0d6",
  null
  
)

export default component.exports